<script setup lang="ts">
/**
 * PentricalLogo — het platform-woordmerk (vijfhoek + "Pentrical").
 *
 * Gebundeld asset: platform-branding hoort niet uit tenant-storage te
 * komen. Gebruikt op de auth-/marketingschermen en als header-fallback
 * voor tenants die nog geen eigen logo hebben ingesteld.
 */

import logoUrl from '../../assets/pentrical-logo.png'

withDefaults(defineProps<{ imgClass?: string }>(), {
  imgClass: 'h-8 w-auto',
})
</script>

<template>
  <img :src="logoUrl" alt="Pentrical" :class="imgClass" />
</template>
